window.ColorBadgeNew = (function () {
  'use strict';

  const FIRST_RANK = -1;
  const OPTION_COLOR_CLASSES = {
    badge: 'option-color__badge option-color__badge--new color-badge-sale',
    stacked: 'option-color__badge--stacked'
  };

  let config;

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function readJson(selector) {
    const node = document.querySelector(selector);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function getConfig() {
    if (config === undefined) {
      const raw = readJson('[data-color-badge-new-config]') || {};
      const colors = new Set(String(raw.colors || '').split(/[,\n]/).map(normalize).filter(Boolean));
      config = colors.size ? { colors: colors, text: String(raw.text || ''), order: raw.order, priority: raw.priority } : null;
    }
    return config;
  }

  function escapeHtml(value) {
    return value.replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function badge(className) {
    return '<span class="' + className + '">' + escapeHtml(getConfig().text) + '</span>';
  }

  return {
    matches: function (code) {
      const settings = getConfig();
      return !!settings && settings.colors.has(normalize(code));
    },

    // Swatch scale: 0 no badge, 1 buy & save; saleRank (-2, 0 or 2) comes from the Sale position setting.
    rank: function (baseRank, saleRank) {
      const settings = getConfig();
      if (!settings) return baseRank;
      if (settings.order === 'first') return Math.min(baseRank, FIRST_RANK);
      if (settings.order === 'sale') return saleRank;
      return baseRank;
    },

    label: function (otherHtml) {
      const settings = getConfig();
      if (!settings || (otherHtml && settings.priority === 'other')) return '';
      return settings.text;
    },

    escapeHtml: escapeHtml,

    badgeHtml: function (otherHtml, classes) {
      const settings = getConfig();
      if (!settings) return otherHtml;
      const names = classes || OPTION_COLOR_CLASSES;
      if (!otherHtml || settings.priority === 'new') return badge(names.badge);
      if (settings.priority === 'other') return otherHtml;
      return otherHtml + badge(names.badge + ' ' + names.stacked);
    }
  };
})();
